/** basic.checkRecord */
export default {
    record_result: "Все результаты проверки",
    record_normal: "Норма",
    record_abnormal: "Аномалия",
    record_checkLog: "Журнал проверки",
    record_checkTime: "Время проверки",
    record_checkConditions: "Детали проверки",
    record_qualityNormal: "Проверка: норма",
    record_qualityAbnormal: "Проверка: аномалия",
}

